'use client';

import { ChakraProvider } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { DesignThemeProvider } from '@/components/core/providers/DesignThemeProvider';
import { EmotionCacheProvider } from '@/components/core/providers/EmotionCacheProvider';
import { PostHogProvider } from '@/components/core/providers/PostHogProvider';
import { Toaster } from '@/components/shared/Toaster';
import { system } from '@/theme';

interface ProvidersProps {
  children: ReactNode;
  nonce?: string;
}

export function Providers({ children, nonce }: ProvidersProps) {
  return (
    <EmotionCacheProvider nonce={nonce}>
      <ChakraProvider value={system}>
        <DesignThemeProvider>
          <PostHogProvider>{children}</PostHogProvider>
          <Toaster />
        </DesignThemeProvider>
      </ChakraProvider>
    </EmotionCacheProvider>
  );
}
